'use strict';
const angular = require('angular');

export class bankingAccountVerificationComponent {

  constructor() {
    'ngInject';
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok() {
    this.close({$value: [this.payment1, this.payment2]});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduApp.bankingAccountVerification', [])
  .component('bankingAccountVerification', {
    template: require('./banking-account-verification.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: bankingAccountVerificationComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/banking-account-verification/banking-account-verification.component.js